<div class="tour-title-wrapper">
    <span multilang class="tour-title">{{'Zimmerkategorien' }}</span>
</div>
<div class="tour-wrapper">
    <ng-container *ngFor="let op of catList">
        <button class=" tour-item-wrapper" (click)="selected(op)" matRipple>
            @if(selectedList.indexOf(op.code) >= 0){
            <img src="../../../../../assets/icons/tickedcheckbox.png" alt="">
            }@else{
            <img src="../../../../../assets/icons/checkbox.png" alt="">
            }
            <span multilang class="tour-item-name">{{op.name }}</span>
        </button>
    </ng-container>
</div>